import styled from 'styled-components';

export const IconLabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  ${({ customStyle }) => customStyle}
`;

export const IconLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
